import { useState, useRef } from "react"

const useTabNavigationWithKeyboard = (tabs, initialActiveSlug) => {
  const tabRef = useRef([])
  const [activeSlug, setActiveSlug] = useState(initialActiveSlug)
  const tabCount = tabs.length

  // Tabs can be added after mount (e.g., once permissions load), shifting their positions,
  // so the active tab is remembered by slug and its index is found in the current tabs.
  const activeSlugIndex = tabs.findIndex(({ slug }) => slug === activeSlug)
  const activeIndex = activeSlugIndex === -1 ? 0 : activeSlugIndex
  const activeTab = tabs[activeIndex]

  const changeActiveTab = (e, index) => {
    e.preventDefault()
    setActiveSlug(tabs[index].slug)
  }

  const moveFocusToTab = (targetIndex) => {
    tabRef.current[targetIndex].focus()
  }

  const moveFocusToPreviousTab = (currentIndex) => {
    if (currentIndex === 0) {
      moveFocusToTab(tabCount - 1)
    } else {
      moveFocusToTab(currentIndex - 1)
    }
  }

  const moveFocusToNextTab = (currentIndex) => {
    if (currentIndex === tabCount - 1) {
      moveFocusToTab(0)
    } else {
      moveFocusToTab(currentIndex + 1)
    }
  }

  const handleKeyDown = (e, index) => {
    const keyActions = {
      ArrowLeft: () => moveFocusToPreviousTab(index),
      ArrowRight: () => moveFocusToNextTab(index),
      ArrowUp: () => moveFocusToPreviousTab(index),
      ArrowDown: () => moveFocusToNextTab(index),
      Home: () => moveFocusToTab(0),
      End: () => moveFocusToTab(tabCount - 1),
    }

    if (keyActions[e.key]) {
      keyActions[e.key]()
      e.preventDefault()
    }
  }

  return {
    activeIndex,
    activeTab,
    tabRef,
    changeActiveTab,
    handleKeyDown,
  }
}

export default useTabNavigationWithKeyboard
